import { formatDateTime } from "../formatDateTime/formatDateTime";
import { formatTimezone } from "../formatTimezone/formatTimezone";
import { getContinentFromTimezone } from "../getContinentFromTimezone/getContinentFromTimezone";
import { TFunction } from "i18next";
import { Timezone } from "../../TimezoneList/TimezoneList";

export const formatIanaTimezoneToDropdownOption = (
  ianaTimezone: string,
  t: TFunction,
): Timezone => {
  return {
    continent: t(
      `timezones.continents.${getContinentFromTimezone(ianaTimezone)}`,
    ),
    dateAndTime: formatDateTime(new Date(), ianaTimezone),
    id: ianaTimezone,
    name: t(`timezones.${formatTimezone(ianaTimezone)}`),
  };
};
